export enum StatusRequest {
  ERROR = "ERROR",
  FETCHING = "FETCHING",
  SUCCESS = "SUCCESS",
}